<s1-input-multiselect class="mb-2" [control]="control" [label]="label" [options]="options" (onFilterChange)="setAnnoAndSearch($event)"></s1-input-multiselect>